import { render } from "./ContentsListItem.vue?vue&type=template&id=2aafbbce&scoped=true"
import script from "./ContentsListItem.vue?vue&type=script&lang=js"
export * from "./ContentsListItem.vue?vue&type=script&lang=js"

import "./ContentsListItem.vue?vue&type=style&index=0&id=2aafbbce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aafbbce"]])

export default __exports__